import { render, staticRenderFns } from "./SocialBlock.vue?vue&type=template&id=f2e759d0&scoped=true"
import script from "./SocialBlock.vue?vue&type=script&lang=js"
export * from "./SocialBlock.vue?vue&type=script&lang=js"
import style0 from "./SocialBlock.vue?vue&type=style&index=0&id=f2e759d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e759d0",
  null
  
)

export default component.exports